import { useMemo } from 'react';
import { Z_INDEX_TICKS } from '../../z-indices';
import { useTicks } from '../utils/use-ticks';
import { useTimelineSize } from '../utils/use-timeline-size';
import { TickHeader } from './tick-header';
import { TickHeaders } from './tick-headers';
import { TicksBackground } from './ticks-background';
import { TICKS_HEIGHT } from '@/features/remotion-editor/editor/timeline/ticks/constants';
import { TIMELINE_DIVDER_HEIGHT } from '@/features/remotion-editor/editor/constants';

export const TimelineTicks: React.FC<{
  visibleFrames: number;
  timelineWidth: number;
}> = ({ visibleFrames, timelineWidth }) => {
  const { containerWidth } = useTimelineSize();

  if (!containerWidth) {
    throw new Error('Container width is null');
  }

  const { tickMarks } = useTicks({
    visibleFrames,
    timelineWidth,
    containerWidth,
  });

  const fillWidth = Math.max(timelineWidth, containerWidth);

  const style: React.CSSProperties = useMemo(() => {
    return {
      zIndex: Z_INDEX_TICKS,
      height: TICKS_HEIGHT,
      marginBottom: TIMELINE_DIVDER_HEIGHT,
    };
  }, []);

  return (
    <div
      className="sticky top-0 bg-sys-bg-surface"
      style={style}
    >
      <TicksBackground timelineWidth={fillWidth} />
      <TickHeaders timelineWidth={fillWidth}>
        {tickMarks.map((tick, i) => (
          <TickHeader
            key={i}
            tick={tick}
          />
        ))}
      </TickHeaders>
    </div>
  );
};
